import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from "src/utils/Utils";
import store from "../../../store";

class ControlPinCheckTask extends AbstractRequestTask {
    constructor(params) {
        super();
        this.ownParams = params;
        this.version = 'v2'; // Cambia a v2
        this.method = 'POST'; // Usando POST
        this.params = super.getParams();
        this.user_token = this.params.user_token;
    }

    getHeaders() {
        return {
            'Authorization': `Bearer ${this.user_token}`,
            'Accept-Language': this.acceptLanguage
        }
    }

    getMethod() {
        return "POST";
    }

    getEncType() {
        return 'application/json';
    }

    getQueryStringParams() {
        const params = super.getParams();
        delete params.api_version;
        delete params.HKS;
        delete params.format;
        delete params.user_id;
        const qsParams = Object.assign({}, params);
        qsParams.pin = this.ownParams.controlPIN;
        return Utils.buildQueryParams(qsParams);
    }

    getParams() {
        const params = super.getParams();
        const user = store.getState().user;
        const user_id = user.user_id || "";
        const pin = this.ownParams.controlPIN;
        delete params.api_version;
        delete params.HKS;
        delete this.ownParams.userId;
        delete params.user_token
        return {
            pin
        };
    }

    getUrl() {
        const protocol = 'https';
        const server = Launcher.get("akamai_mfwk");
        const endpoint = 'services/user';
        const apiname = 'controlpin/check';
        const version = this.version;

        return `${protocol}://${server}/${endpoint}/${version}/${apiname}?${this.getQueryStringParams()}`;
    }
}

export default ControlPinCheckTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/user/ControlPinCheckTask.js